import React, { useState } from 'react';
import { Button } from './ui/button';
import { ShieldCheck, AlertTriangle } from 'lucide-react';

const AgeGate = ({ onVerified }) => {
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    setLoading(true);
    // Small delay for UX
    await new Promise(resolve => setTimeout(resolve, 300));
    localStorage.setItem('age_verified', 'true');
    onVerified();
    setLoading(false);
  };

  const handleExit = () => {
    window.location.href = 'https://www.google.com';
  };

  return (
    <div className="age-gate" data-testid="age-gate">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1759230766134-e3ff1c27d20e?w=1920)' }}
      />
      
      <div className="age-gate-content relative z-10 animate-fade-in" data-testid="age-gate-content">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center shadow-lg shadow-purple-500/30">
            <ShieldCheck className="w-10 h-10 text-white" />
          </div>
        </div>

        <h1 className="text-4xl md:text-5xl font-normal tracking-wide uppercase mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
          VelvetStream
        </h1>
        
        <p className="text-gray-300 mb-2 text-lg font-medium">
          Adult Entertainment
        </p>

        <div className="w-16 h-0.5 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto mb-6" />
        
        <div className="bg-[#1A1A1A]/80 border border-white/10 rounded-lg p-6 mb-6">
          <div className="flex items-start gap-3 mb-4">
            <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
            <p className="text-gray-300 text-sm text-left leading-relaxed">
              This website contains <span className="text-white font-medium">adult content</span> intended for individuals who are <span className="text-white font-medium">18 years of age or older</span>.
            </p>
          </div>
          
          <p className="text-gray-400 text-xs text-left">
            By clicking "I Am 18+" below, you confirm that you are of legal age to view adult content in your jurisdiction.
          </p>
        </div>

        <div className="space-y-3">
          <Button 
            onClick={handleVerify}
            disabled={loading}
            className="w-full h-14 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 text-white font-bold tracking-wide uppercase text-lg shadow-lg shadow-purple-500/30 transition-all duration-300 hover:scale-[1.02]"
            data-testid="age-verify-btn"
          >
            {loading ? 'Entering...' : 'I Am 18+ — Enter'}
          </Button>
          
          <Button 
            variant="outline"
            onClick={handleExit}
            className="w-full h-12 border-white/20 bg-transparent text-gray-400 hover:bg-white/5 hover:text-white"
            data-testid="age-exit-btn"
          >
            Leave Site
          </Button>
        </div>

        <p className="text-xs text-gray-500 mt-6 leading-relaxed">
          By entering, you agree to our Terms of Service and confirm that viewing adult content is legal in your area.
        </p>
      </div>
    </div>
  );
};

export default AgeGate;
